import React from 'react'

import { Spring } from 'react-spring/renderprops'
import { TransitionState } from 'gatsby-plugin-transition-link'
import SEO from "components/globals/seo"

export default ({
    children,
    title,
    description
}) => {
    return (
        <>
            <SEO title={title} description={description} />
            <TransitionState>
                {({ transitionStatus, exit, entry }) => {
                    const mount = ['entering', 'entered'].includes(transitionStatus)
                    const seconds = mount ? entry.length : exit.length

                    return (
                        <Spring
                            to={{
                                transform: `translateY(${mount ? 0 : '-20px'})`,
                                opacity: mount ? 1 : 0,
                            }}
                            config={{
                                duration: seconds * 1000,
                            }}
                            delay={mount ? 300 : 0}
                        >
                            {props => {
                                return (
                                    <div style={{
                                        ...props,
                                        backgroundColor: 'white'
                                    }}>
                                        { children }
                                    </div>
                                )
                            }}
                        </Spring>
                    )
                }}
            </TransitionState>
        </>
    )
}